module.exports = __webpack_public_path__ + "static/media/contact17.2927f0ea.png";